import {
  EDIT_TASK_GROUP,
  GET_SUB_TASKS,
  GET_TASK_GROUPS,
  RESTORE_TASK_GROUP,
  SERVER_URL,
  TASK_GROUP_ADD,
  TASK_GROUP_DELETE,
  TASK_MOVE_TO_GROUP,
} from "@pma/utils/api-routes"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import axios from "axios"
import { parseCookies } from "nookies"

export interface ITasksRequestPayload {
  project_id: number
  paging_start_page: number
  paging_per_page: number
  paging_offset?: number
  status_id?: number[]
  responsible_id?: number[]
  priority_id?: number[]
  search_text?: string
  start_at_period?: {
    from: string
    to: string
  }
  finish_to_period?: {
    from: string
    to: string
  }
  created_at_period?: {
    from: string
    to: string
  }
  sorting?: {
    orderBy: "asc" | "desc" | string
    sortBy: string
  }
  by_active_sessions?: boolean
  show_deleted?: boolean
}

export interface IGroupInput {
  group_name: string
  project_id: number
}

export interface IGroupUpdateInput {
  group_name: string
  group_id: number
}

export interface IGroupDeleteInput {
  group_id: number
}

export interface IGroupMoveTaskToGroupInput {
  with_users: boolean
  task_id: number
  inform_users: boolean
  target_group_id: number | null
}

export interface IGroupSubTaskInput {
  status_id?: [number]
  responsible_id?: [number]
  by_active_sessions?: boolean
  parent_task_id?: number
  start_at_period?: {
    from: Date
    to: Date
  }
  finish_to_period?: {
    from: Date
    to: Date
  }
  created_at_period?: {
    from: Date
    to: Date
  }
  sorting?: {
    orderBy: "asc" | "desc"
    sortBy: string
  }
}

function getTasks(payload: ITasksRequestPayload) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${GET_TASK_GROUPS}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function createGroup(payload: IGroupInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${TASK_GROUP_ADD}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function updateGroup(payload: IGroupUpdateInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${EDIT_TASK_GROUP}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function deleteGroup(group_id: IGroupDeleteInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${TASK_GROUP_DELETE}${group_id}`
  return axios.delete(url, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function moveTaskToGroup(payload: IGroupMoveTaskToGroupInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${TASK_MOVE_TO_GROUP}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function fetchSubTasks(payload: IGroupSubTaskInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${GET_SUB_TASKS}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}

function restoreGroup(payload: IGroupUpdateInput) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = `${SERVER_URL}${RESTORE_TASK_GROUP}`
  return axios.post(url, payload, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  })
}


const GROUPED_TASKS_SERVICE = {
  getTasks,
  createGroup,
  updateGroup,
  deleteGroup,
  moveTaskToGroup,
  fetchSubTasks,
  restoreGroup
}

export default GROUPED_TASKS_SERVICE
